import _Link from './Link';

import './style/index.js';

export type { LinkProps } from './Link';

export const Link = _Link;

export default Link;
